'use client';

import ExperimentComponent from '@/app/components/ExperimentComponent/ExperimentComponent';
import type { ActiveExperiments } from '@/app/consts/activeExperiments';

import ContentControl from './content-control';
import ContentRedesign from './content-redesign';

interface ContentProps {
  readonly localePartialUrl: string;
}

const Content = ({ localePartialUrl }: ContentProps) => {
  return (
    <ExperimentComponent
      experimentName={'membership_redesign' as ActiveExperiments}
      control={<ContentControl localePartialUrl={localePartialUrl} />}
    >
      <ContentRedesign />
    </ExperimentComponent>
  );
};

export default Content;
